<template lang="pug">
    #settings.page
        h4.title.is-4 Application settings
        form.form(@submit.prevent="saveAppSettings")
            .columns
                .field.column.is-3-fullhd.is-4-desktop.is-12-mobile
                    label.label Forecast mailing crontime
                    .control
                        input.input(type="text" v-model="settings.forecastMailTime")
            .columns
                .field.column.is-3-fullhd.is-4-desktop.is-12-mobile
                    label.label Forecast e-mail
                    .control
                        input.input(type="text" v-model="settings.forecastEMail")
            .columns
                .field.column.is-3-fullhd.is-4-desktop.is-12-mobile
                    label.label Timezone
                    .control
                        input.input(type="number" min="-12" max="12" v-model="settings.timezone")
            .columns
                .field.column.is-3-fullhd.is-4-desktop.is-12-mobile
                    .control
                        button.button.is-primary(type="submit" :class="{ 'is-loading': isLoading }") Save
                    hr
        h4.title.is-4 Application restart
        .columns
            .field.column.is-3-fullhd.is-4-desktop.is-12-mobile
                label.label Manual restart
                .control
                    button.button.is-info(@click="restartApp") Restart
</template>

<script>
export default {
  name: "Settings",
  data: () => ({ isLoading: false }),
  computed: {
    settings() {
      return this.$store.state.app.settings.reduce(
        (obj, item) => ({ ...obj, [item.key]: item.value }),
        {}
      );
    }
  },
  methods: {
    restartApp() {
      if (confirm("Restart App?")) {
        this.$store.dispatch("restartApp").then(console.log);
      }
    },
    saveAppSettings() {
      const data = Object.keys(this.settings).map(key => ({
        key,
        value: this.settings[key]
      }));
      this.isLoading = true;
      this.$store
        .dispatch("saveAppSettings", data)
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Save App setting error",
            text
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    if (!this.$store.state.app.settings.length) {
      this.$store.commit("isLoading", {
        key: "App settings",
        status: true
      });
      this.$store
        .dispatch("getAppSettings")
        .catch(console.log)
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "App settings",
            status: false
          });
        });
    }
  }
};
</script>

<style lang="scss">
#settings {
  .columns {
    .label {
      color: $white;
    }
  }
}
</style>
